import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { AlertService } from '../../shared/alert/alert.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LotImportDepositMappingDialogComponent } from './lot-import-deposit-mapping.dialog.component';
import { parseFile } from '../../shared/util/file-utils';
import { InventoryService } from '../../shared/inventory/service/inventory.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-import-deposit-dialog',
    templateUrl: './lot-import-deposit-dialog.component.html'
})
export class LotImportDepositDialogComponent implements OnInit, OnDestroy {

    @ViewChild('fileUpload')
        fileUpload: ElementRef;

    fileName = '';
    importData = new Array<any>();
    selectedFileType = '.xls,.xlsx,.csv';
    subscriptionsManager = new SubscriptionsManager();

    constructor(
        private alertService: AlertService,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal) {

    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {

    }

    import() {
        if (this.validateFileEmpty()) {
            const confirmModalRef = this.modalService.open(LotImportDepositMappingDialogComponent as Component, { size: 'lg', backdrop: 'static' });
            confirmModalRef.componentInstance.importData = this.importData;
            confirmModalRef.result.then(() => {
                this.close();
            });
        }
    }

    clearSelectedFile(): void {
        this.importData = null;
    }


    onFileChange(evt: any) {
        const target = evt.target;
        this.fileName = target.files[0].name;

        const extension = this.fileName.split('.');
        if (extension[1].toLowerCase() !== 'xls' && extension[1].toLowerCase() !== 'xlsx' && extension[1].toLowerCase() !== 'csv' ) {
            this.fileName = '';
            target.value = '';
            this.alertService.error('inventoryManagerApp.error.import.invalid.file.ext');
            return;
        }

        this.subscriptionsManager.add = parseFile(target.files[0], '').subscribe((value) => {
            this.importData = value;
        });
    }

    close() {
        this.activeModal.dismiss('cancel');
    }

    private validateFileEmpty() {
        if (!this.importData || this.importData.filter((row) => row.some((column) => Boolean(column.trim()))).length <= 1) {
            this.alertService.error('error.import.file.empty');
            return false;
        }
        return true;
    }
}

@Component({
    selector: 'jhi-lot-import-deposit-popup',
    template: ''
})
export class LotImportDepositPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(private inventoryService: InventoryService,
                private alertService: AlertService,
                private route: ActivatedRoute,
                private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(() => {
            this.popupService.open(LotImportDepositDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

}
